const config = {
    appName: 'Wordle',
    productName: '7A Wordle',
    productDetail: 'SEPM 2022 S1',
    developTeam: 'SEPM team 7A',
    sprint: 'Sprint 2',
    wordLength: 5,
}

export default config;
